import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const MARCAS = ['Chevrolet','Volkswagen','Ford','Fiat','Toyota','Honda','Dodge','Jeep','Willys','Alfa Romeo','Mercedes-Benz','BMW','Porsche','Jaguar','Triumph','MG','DKW','Simca'];
const UFs    = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

export default function Veiculos() {
  const { emTrial, diasTrial, assinatura } = useAuth();
  const [veiculos, setVeiculos]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [total, setTotal]         = useState(0);
  const [pagina, setPagina]       = useState(1);
  const [filtros, setFiltros]     = useState({ marca:'', ano_min:'', ano_max:'', preco_max:'', estado:'', cambio:'', original:'', placa_preta:'' });

  const buscar = async (f = filtros, p = pagina) => {
    setLoading(true);
    try {
      const q = new URLSearchParams({ ...f, page: p, limit: 12 });
      Object.keys(f).forEach(k => { if (!f[k]) q.delete(k); });
      const { data } = await api.get(`/veiculos?${q}`);
      setVeiculos(data.veiculos); setTotal(data.total);
    } catch {} finally { setLoading(false); }
  };

  useEffect(() => { buscar(filtros, pagina); }, [pagina]);

  const updF   = e => setFiltros(f => ({ ...f, [e.target.name]: e.target.value }));
  const aplicar = () => { setPagina(1); buscar(filtros, 1); };
  const limpar  = () => { const f={}; setFiltros(f); setPagina(1); buscar(f, 1); };

  const fmtPreco = v => v ? `R$ ${Number(v).toLocaleString('pt-BR')}` : 'A consultar';
  const dias = diasTrial();
  const isTrial = emTrial();

  return (
    <>
      <Navbar />
      <div style={{ background: 'var(--cream)', minHeight: 'calc(100vh - 112px)', padding: '48px 0' }}>
        <div className="container">

          {/* Trial banner */}
          {isTrial && (
            <div style={{ background: 'linear-gradient(135deg,rgba(216,189,105,.18),rgba(154,86,55,.08))', border: '1px solid rgba(216,189,105,.35)', borderRadius: 'var(--r-md)', padding: '14px 20px', marginBottom: 28, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16 }}>
              <p style={{ fontSize: 13, color: 'var(--ink)', lineHeight: 1.5 }}>
                <strong>Período de teste:</strong> {dias} dia{dias !== 1 ? 's' : ''} restante{dias !== 1 ? 's' : ''}. Primeira cobrança de R$ {Number(assinatura?.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })} em {assinatura?.data_renovacao ? new Date(assinatura.data_renovacao).toLocaleDateString('pt-BR') : '—'}.
              </p>
              <Link to="/minha-assinatura" style={{ fontSize: 11, color: 'var(--rust)', fontWeight: 900, letterSpacing: 1, textTransform: 'uppercase', flexShrink: 0 }}>Gerenciar →</Link>
            </div>
          )}

          <div className="page-header">
            <div className="eyebrow">Área de compra</div>
            <h1 className="section-title">Veículos disponíveis</h1>
            <div className="gold-rule" />
            <p style={{ color: 'var(--ink-muted)', fontSize: 14 }}>{total} veículo{total !== 1 ? 's' : ''} encontrado{total !== 1 ? 's' : ''}</p>
          </div>

          {/* Filtros */}
          <div className="filtros">
            <div className="filtros-grid">
              <div className="form-group">
                <label>Marca</label>
                <select name="marca" value={filtros.marca} onChange={updF}>
                  <option value="">Todas</option>
                  {MARCAS.map(m => <option key={m}>{m}</option>)}
                </select>
              </div>
              <div className="form-group"><label>Ano mínimo</label><input type="number" name="ano_min" value={filtros.ano_min} onChange={updF} placeholder="1940" min="1900" max="2000" /></div>
              <div className="form-group"><label>Ano máximo</label><input type="number" name="ano_max" value={filtros.ano_max} onChange={updF} placeholder="2000" min="1900" max="2000" /></div>
              <div className="form-group"><label>Preço máximo</label><input type="number" name="preco_max" value={filtros.preco_max} onChange={updF} placeholder="R$ 150.000" /></div>
              <div className="form-group">
                <label>Estado</label>
                <select name="estado" value={filtros.estado} onChange={updF}>
                  <option value="">Todos</option>
                  {UFs.map(e => <option key={e}>{e}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Câmbio</label>
                <select name="cambio" value={filtros.cambio} onChange={updF}>
                  <option value="">Todos</option>
                  <option value="manual">Manual</option>
                  <option value="automatico">Automático</option>
                </select>
              </div>
              <div className="form-group">
                <label>Original</label>
                <select name="original" value={filtros.original} onChange={updF}>
                  <option value="">Todos</option>
                  <option value="1">Somente originais</option>
                </select>
              </div>
              <div className="form-group">
                <label>Placa preta</label>
                <select name="placa_preta" value={filtros.placa_preta} onChange={updF}>
                  <option value="">Todos</option>
                  <option value="1">Com placa preta</option>
                </select>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
              <button className="btn btn-primary btn-sm" onClick={aplicar}>Filtrar</button>
              <button className="btn btn-outline btn-sm" onClick={limpar}>Limpar</button>
            </div>
          </div>

          {/* Grid */}
          {loading ? (
            <p style={{ textAlign: 'center', padding: 60, color: 'var(--ink-muted)' }}>Carregando veículos…</p>
          ) : veiculos.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 60 }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>🔍</div>
              <p style={{ color: 'var(--ink-muted)', fontSize: 15 }}>Nenhum veículo encontrado com os filtros selecionados.</p>
            </div>
          ) : (
            <div className="veiculos-grid">
              {veiculos.map(v => (
                <Link to={`/veiculos/${v.id}`} key={v.id}>
                  <div className="card card-hover veiculo-card">
                    <div className="foto">
                      {v.foto_principal
                        ? <img src={v.foto_principal} alt={`${v.marca} ${v.modelo}`} />
                        : <div className="foto-placeholder">🚗</div>}
                      {v.destaque && (
                        <span style={{ position:'absolute', top:10, left:10, background:'var(--rust)', color:'#fff', fontSize:9, padding:'4px 10px', borderRadius:'var(--r-sm)', fontWeight:900, letterSpacing:1, textTransform:'uppercase' }}>Destaque</span>
                      )}
                    </div>
                    <div className="info">
                      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
                        <span className={`badge badge-${v.status}`}>{v.status?.replace('_',' ')}</span>
                        <span style={{ fontSize:11, color:'var(--ink-muted)' }}>{v.estado}</span>
                      </div>
                      <div className="v-title">{v.marca} {v.modelo}</div>
                      <div className="v-meta">{v.versao && `${v.versao} · `}{v.ano} · {v.cambio}</div>
                      <div className="v-price">{fmtPreco(v.preco)}</div>
                      <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginTop:6 }}>
                        {!!v.original    && <span style={{ fontSize:9, background:'rgba(30,125,71,.12)', color:'#1e7d47', padding:'3px 8px', borderRadius:'var(--r-sm)', fontWeight:900, letterSpacing:.5, textTransform:'uppercase' }}>Original</span>}
                        {!!v.placa_preta && <span style={{ fontSize:9, background:'#1a1208', color:'var(--gold)', padding:'3px 8px', borderRadius:'var(--r-sm)', fontWeight:900, letterSpacing:.5, textTransform:'uppercase' }}>Placa preta</span>}
                        {!!v.restaurado  && <span style={{ fontSize:9, background:'rgba(37,99,235,.1)', color:'#2563eb', padding:'3px 8px', borderRadius:'var(--r-sm)', fontWeight:900, letterSpacing:.5, textTransform:'uppercase' }}>Restaurado</span>}
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}

          {/* Paginação */}
          {total > 12 && (
            <div className="paginacao">
              <button disabled={pagina === 1} onClick={() => setPagina(p => p - 1)}>← Anterior</button>
              <span style={{ fontSize:12, color:'var(--ink-muted)', padding:'0 8px' }}>Página {pagina} de {Math.ceil(total/12)}</span>
              <button disabled={pagina >= Math.ceil(total/12)} onClick={() => setPagina(p => p + 1)}>Próxima →</button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
